"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlaybackContextProvider = exports.useMediaPlaybackContext = exports.MediaPlaybackContext = void 0;

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

exports.MediaPlaybackContext = react_1.default.createContext(undefined);

var useMediaPlaybackContext = function useMediaPlaybackContext() {
  var val = react_1.default.useContext(exports.MediaPlaybackContext);

  if (!val) {
    throw new Error('A media playback context could not be found.');
  }

  return val;
};

exports.useMediaPlaybackContext = useMediaPlaybackContext;

function MediaPlaybackContextProvider(_ref) {
  var propDuration = _ref.duration,
      onProgress = _ref.onProgress,
      _ref$allowSeek = _ref.allowSeek,
      allowSeek = _ref$allowSeek === void 0 ? true : _ref$allowSeek,
      children = _ref.children;

  var _react_1$default$useS = react_1.default.useState(propDuration || 0),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      duration = _react_1$default$useS2[0],
      _setDuration = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState({
    played: 0,
    playedSeconds: 0,
    loaded: 0,
    loadedSeconds: 0
  }),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      progress = _react_1$default$useS4[0],
      setProgress = _react_1$default$useS4[1];

  react_1.default.useEffect(function () {
    if (onProgress) {
      onProgress(progress);
    }
  }, [progress]);

  var _react_1$default$useS5 = react_1.default.useState(false),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      isBuffering = _react_1$default$useS6[0],
      setIsBuffering = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState(1),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      playbackSpeed = _react_1$default$useS8[0],
      setPlaybackSpeed = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(1),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      volume = _react_1$default$useS10[0],
      setVolume = _react_1$default$useS10[1];

  var _react_1$default$useS11 = react_1.default.useState(false),
      _react_1$default$useS12 = _slicedToArray(_react_1$default$useS11, 2),
      isPlaying = _react_1$default$useS12[0],
      setIsPlaying = _react_1$default$useS12[1];

  var _react_1$default$useS13 = react_1.default.useState([]),
      _react_1$default$useS14 = _slicedToArray(_react_1$default$useS13, 2),
      blocks = _react_1$default$useS14[0],
      setBlocks = _react_1$default$useS14[1];

  var _react_1$default$useS15 = react_1.default.useState(function () {
    return function () {
      return null;
    };
  }),
      _react_1$default$useS16 = _slicedToArray(_react_1$default$useS15, 2),
      onSeek = _react_1$default$useS16[0],
      _setOnSeek = _react_1$default$useS16[1];

  var _react_1$default$useS17 = react_1.default.useState(false),
      _react_1$default$useS18 = _slicedToArray(_react_1$default$useS17, 2),
      fullscreen = _react_1$default$useS18[0],
      setFullscreen = _react_1$default$useS18[1];

  var playerRef = react_1.default.useRef(); // Don't override the duration if we've already set it from the server.

  var setDuration = function setDuration() {
    if (!propDuration) {
      _setDuration.apply(void 0, arguments);
    }
  };

  react_1.default.useEffect(function () {
    if (propDuration) setDuration(propDuration);
  }, [propDuration]);
  react_1.default.useEffect(function () {
    if (isPlaying && (blocks === null || blocks === void 0 ? void 0 : blocks.length)) {
      setBlocks([]);
    }
  }, [isPlaying]);
  var staticContext = react_1.default.useMemo(function () {
    return {
      blockPlaying: function blockPlaying(identifier) {
        return setBlocks(function (blk) {
          return (0, lodash_1.uniq)([].concat(_toConsumableArray(blk), [identifier]));
        });
      },
      unblockPlaying: function unblockPlaying(identifier) {
        return setBlocks(function (blk) {
          return blk.filter(function (item) {
            return item !== identifier;
          });
        });
      },
      setOnSeek: function setOnSeek(val) {
        return _setOnSeek(function () {
          return val;
        });
      },
      setIsBuffering: setIsBuffering,
      setDuration: setDuration,
      setProgress: setProgress,
      setFullscreen: setFullscreen,
      onSetPlaying: setIsPlaying,
      setPlaybackSpeed: setPlaybackSpeed,
      setVolume: setVolume
    };
  }, []);
  var contextValue = Object.assign(Object.assign({}, staticContext), {
    isPlaying: isPlaying && blocks.length === 0,
    isBuffering: isBuffering,
    duration: duration,
    blocks: blocks,
    playedPercentage: progress.played,
    playedSeconds: progress.playedSeconds,
    loadedPercentage: progress.loaded,
    loadedSeconds: progress.loadedSeconds,
    onSeek: onSeek,
    playerRef: playerRef,
    fullscreen: fullscreen,
    playbackSpeed: playbackSpeed,
    volume: volume,
    allowSeek: allowSeek
  });
  return react_1.default.createElement(exports.MediaPlaybackContext.Provider, {
    value: contextValue,
    children: children
  });
}

exports.MediaPlaybackContextProvider = MediaPlaybackContextProvider;